import ReactGA4 from "react-ga4"

const measurementId = import.meta.env.VITE_GA_MEASUREMENT_ID

if (measurementId) {
  ReactGA4.initialize(measurementId);
}

//Track Page Views

export const trackPageView = (path: string) => {
    if (!measurementId) return;

    ReactGA4.send({ hitType: "pageview", page: path });
}

//Track Generic Events

export const trackEvent = (eventName: string, eventParams?: Record<string, unknown>) => {
    if (!measurementId) return;

    ReactGA4.event(eventName, eventParams);
}